document.addEventListener("alpine:init", () => {
    Alpine.data("ClubMap", () => ({
        openFilters: false,
        currentFilters: {},
        clubGrid: null,
        clubs: [],
        map: null,
        markers: [],
        homeMarker: null,
        numberMarkers: [],
        activeMarker: 'Wimbledon',
        latlngBounds: null,
        infoWindow: null,
        homeLocation: {
            lat: null,
            lng: null,
        },
        activeTab: "list",
        filterPrefix: {
            taxonomy: "filter-t-",
            search: "",
        },
        postcode: "",
        geocoder: null,
        isMobile: window.innerWidth <= 1024,
        bounds: null,
        isLoading: false,

        init() {
            this.fetchClubDataFromDOM();
            this.clubGrid = this.$el;
            this.currentFilters = this.getCurrentFilters();

            this.homeLocation.lat = this.$el.dataset.homeLat
                ? parseFloat(this.$el.dataset.homeLat)
                : null;
            this.homeLocation.lng = this.$el.dataset.homeLng
                ? parseFloat(this.$el.dataset.homeLng)
                : null;

            this.geocoder = new google.maps.Geocoder();
            this.latlngBounds = new google.maps.LatLngBounds();

            this.refreshMap();

            window.addEventListener("resize", () => {
                this.isMobile = window.innerWidth <= 1024;
            });
        },

        refreshMap() {
            this.bounds = new google.maps.LatLngBounds();
            this.initMap().then((map) => {
                this.setAllMarkers(map)
                    .then((markers) => {
                        markers.forEach((marker) => {
                            this.bounds.extend(marker.position);
                        });

                        map.fitBounds(this.bounds);

                        map.addListener("zoom_changed", function () {
                            if (map.getZoom() > 17) {
                                map.setZoom(17);
                            }
                        });

                        return markers;
                    })
                    .then((markers) => {
                        window.addEventListener("search-location", (e) => {
                            if (e.detail.location === "") {
                                this.refreshMap();
                            }
                            this.clearMarkers(markers);
                            this.searchLocation(e.detail.location, map);
                        });

                        this.getLocationAndHighlight = () => {
                            this.isLoading = true;
                            this.clearMarkers(markers);
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition((position) => {
                                    this.isLoading = false;
                                    this.searchLocation('position', map, position);
                                });
                            }
                        }
                    })
                    .then(() => {
                        this.map = map;
                        setTimeout(() => {
                            window.dispatchEvent(new Event("resize"));
                        }, 500);
                    });
            });
        },

        initMap() {
            return new Promise(async (resolve, reject) => {
                const center = new google.maps.LatLng(51.5112896, -0.1380377);
                const { Map } = await google.maps.importLibrary("maps");

                const map = new Map(document.getElementById("clubs-map"), {
                    center: center,
                    zoom: 12,
                    mapId: "a24ebe9eba8c374",
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    zoomControl: true,
                    disableDefaultUI: true 
                });

                this.infoWindow = new google.maps.InfoWindow({
                    content: "",
                });

                resolve(map);
            });
        },

        setAllMarkers(map) {
            return new Promise(async (resolve, reject) => {
                const { AdvancedMarkerElement } =
                    await google.maps.importLibrary("marker");

                const defaultIconUrl = "/wp-content/uploads/2024/08/map-marker.svg";
                const hoverIconUrl = "/wp-content/uploads/2024/08/map-marker-active.svg";

                const isInsideHoverContainer = document.querySelector('.Club__Map_Hover') !== null;

                let lastActiveMarker = null;

                this.markers = this.clubs.map((club, index) => {
                    const position = {
                        lat: parseFloat(club.lat),
                        lng: parseFloat(club.lng),
                    };
                    const markerIcon = document.createElement("img");
                    markerIcon.src = defaultIconUrl;
                    markerIcon.style.width = "40px";
                    markerIcon.style.height = "40px";
                    const markerId = index + 1;

                    let markerObject = {
                        position: position,
                        map: map,
                        title: club.title,
                        content: markerIcon,
                        id: markerId 
                    };

                    const marker = new AdvancedMarkerElement(markerObject);

                    const formattedAddress = club.address.replace(
                        /\|/g,
                        "<br>"
                    );

                    // Create the content for the InfoWindow
                    const infoContent = `
                        <a href="${club.url}" target="_blank" class="club-info-window">
                            <div>
                                <h3>${club.title}</h3>
                                <p class="address">${formattedAddress}</p>
                            </div>
                            <img src="${club.image}" alt="${club.title}">
                        </a>
                    `;

                    marker.addListener("click", () => {
                        if (!(this.isMobile && isInsideHoverContainer)) {
                            this.infoWindow.setContent(infoContent);
                            this.infoWindow.open(this.map, marker);
                        }
                    });

                    marker.content.addEventListener('mouseenter', () => {
                        if (lastActiveMarker && lastActiveMarker !== marker) {
                            lastActiveMarker.content.src = defaultIconUrl;
                        }
        
                        markerIcon.src = hoverIconUrl;
                        this.activeMarker = club.title;
                        lastActiveMarker = marker;
                    });

                    marker.content.addEventListener("touchstart", () => {
                        if (lastActiveMarker && lastActiveMarker !== marker) {
                            lastActiveMarker.content.src = defaultIconUrl;
                        }
        
                        markerIcon.src = hoverIconUrl;
                        this.activeMarker = club.title;
                        lastActiveMarker = marker;
                    });

                    return marker;
                });

                resolve(this.markers);
            });
        },

        setActiveTab(tab) {
            if (this.isMobile) {
                this.activeTab = tab;
            }
        },

        fetchClubDataFromDOM() {
            const clubElements = document.querySelectorAll(".club");
            this.clubs = Array.from(clubElements).map((clubEl) => ({
                id: clubEl.getAttribute("id"),
                lat: parseFloat(clubEl.getAttribute("data-lat")),
                lng: parseFloat(clubEl.getAttribute("data-lng")),
                distance: null,
                active: clubEl.getAttribute("data-active"),
                title: clubEl.getAttribute("data-title"),
                address: clubEl.getAttribute("data-address"),
                image: clubEl.getAttribute("data-image"),
                url: clubEl.getAttribute("data-url"),
                element: clubEl,
            }));
        },

        searchLocation(locationQuery, map, position = null) {
            let geoObject;
            if(position) {
                const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                geoObject = {
                    latLng
                }
            } else {
                geoObject = {
                    address: locationQuery
                }
            }
            if (locationQuery.length > 0) {
                this.geocoder.geocode(
                    geoObject,
                    (results, status) => {
                        if (status === "OK") {
                            document
                                .querySelector(".ClubMap__Search")
                                .classList.remove("error");

                            const searchLocation = results[0].geometry.location;
                            this.map.setCenter(searchLocation);

                            // Update the home location marker
                            this.homeLocation.lat = searchLocation.lat();
                            this.homeLocation.lng = searchLocation.lng();

                            this.addHomeLocationMarker(map);

                            // Recalculate distances to clubs and filter
                            this.updateClubDistances(searchLocation);

                            // Add the numbered markers after sorting clubs
                            this.addNumberedClubMarkers(map);

                            // Extend bounds to include the new search location
                            if (this.latlngBounds) {
                                this.latlngBounds.extend(searchLocation);
                                this.map.fitBounds(this.latlngBounds);
                            } else {
                                console.error('latlngBounds is not initialized');
                            }
                        } else {
                            document
                                .querySelector(".ClubMap__Search")
                                .classList.add("error");
                        }
                    }
                );
            }
        },

        getLocationAndHighlight() {
            return null;
        },

        highlightClosestMarker(location) {
            let closestMarker = null;
            let closestDistance = Infinity;

            this.markers.forEach((marker) => {
                if (marker === this.searchMarker) {
                    return;
                }

                const markerPosition = marker.getPosition();
                const distance =
                    google.maps.geometry.spherical.computeDistanceBetween(
                        location,
                        markerPosition
                    );

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestMarker = marker;
                }
            });

            if (closestMarker) {
                if (
                    this.activeMarker &&
                    this.activeMarker !== this.searchMarker
                ) {
                    this.activeMarker.setIcon(this.normalMarkerIcon);
                }

                this.activeMarker = closestMarker;
                this.activeMarker.setIcon(this.activeMarkerIcon);
                this.map.panTo(this.activeMarker.getPosition());

                const closestMarkerData = this.markers.find(
                    (m) =>
                        m.position.lat === closestMarker.getPosition().lat() &&
                        m.position.lng === closestMarker.getPosition().lng()
                );

                if (closestMarkerData) {
                    this.updateSelectedMarker(closestMarkerData);
                }
            }
        },

        updateClubDistances(searchLocation) {
            // Recalculate distances to each club
            this.clubs = this.clubs.map((club) => {
                const distanceInKm = this.calculateDistance(searchLocation, {
                    lat: club.lat,
                    lng: club.lng,
                });
                const distanceInMiles = distanceInKm * 0.621371;
                club.distance = distanceInMiles.toFixed(2);

                // Update the DOM element with the distance
                const clubElement = club.element;
                const distanceElement = clubElement.querySelector(".distance");
                if (distanceElement) {
                    distanceElement.textContent = `${club.distance} miles`;
                }

                return club;
            });

            // Sort clubs by distance
            this.clubs.sort((a, b) => a.distance - b.distance);

            this.reorderClubCards();
        },

        calculateDistance(location1, location2) {
            const R = 6371;
            const dLat = this.deg2rad(location2.lat - location1.lat());
            const dLng = this.deg2rad(location2.lng - location1.lng());
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.deg2rad(location1.lat())) *
                Math.cos(this.deg2rad(location2.lat)) *
                Math.sin(dLng / 2) *
                Math.sin(dLng / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        },

        deg2rad(deg) {
            return deg * (Math.PI / 180);
        },

        reorderClubCards() {
            const clubGrid = this.clubGrid
                ? this.clubGrid.querySelector("[data-pegasus-filterable]")
                : null;

            if (clubGrid) {
                this.clubs.forEach((club) => {
                    clubGrid.appendChild(club.element);
                });
            }
        },

        clearMarkers(markers) {
            markers.forEach((marker) => {
                if (marker) {
                    marker.setMap(null);
                    marker = null;
                }
            });

            this.markers = [];
        },

        addNumberedClubMarkers(map) {
            return new Promise(async (resolve, reject) => {
                try {
                    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

                    this.latlngBounds = new google.maps.LatLngBounds();

                    // Loop through the sorted clubs array and add numbered markers
                    this.clubs.forEach((club, index) => {
                        const position = {
                            lat: parseFloat(club.lat),
                            lng: parseFloat(club.lng),
                        };

                        const markerLabel = (index + 1).toString();

                        const markerIcon = document.createElement("div");
                        markerIcon.classList.add("number-marker");
                        markerIcon.textContent = markerLabel;

                        // Create the numbered marker for each club with a label
                        const marker = new AdvancedMarkerElement({
                            position: position,
                            map: map,
                            content: markerIcon,
                            title: club.title,
                        });

                        // Replace the | with <br> to restore line breaks in the address
                        const formattedAddress = club.address.replace(
                            /\|/g,
                            "<br>"
                        );

                        // Create the content for the InfoWindow
                        const infoContent = `
                        <a href="${club.url}" target="_blank" class="club-info-window">
                            <div>
                                <h3>${club.title}</h3>
                                <p class="address">${formattedAddress}</p>
                            </div>
                            <img src="${club.image}" alt="${club.title}" style="width:100px;height:auto;">
                        </a>
                        `;

                        // Add click event listener for each marker to open the pop-up
                        marker.addListener("click", () => {
                            this.infoWindow.setContent(infoContent);
                            this.infoWindow.open(this.map, marker);
                        });

                        this.latlngBounds.extend(position);
                        this.numberMarkers.push(marker);
                    });

                    this.map.fitBounds(this.latlngBounds);
                    resolve(this.markers);
                } catch (error) {
                    reject(error);
                }
            });
        },

        addHomeLocationMarker(map) {
            if (this.homeMarker !== null) {
                this.homeMarker.setMap(null);
            }
            return new Promise(async (resolve, reject) => {
                const { AdvancedMarkerElement } =
                    await google.maps.importLibrary("marker");

                if (
                    this.homeLocation.lat !== null &&
                    this.homeLocation.lng !== null
                ) {
                    const homePosition = {
                        lat: parseFloat(this.homeLocation.lat),
                        lng: parseFloat(this.homeLocation.lng),
                    };

                    if (!isNaN(homePosition.lat) && !isNaN(homePosition.lng)) {
                        this.homeMarker = new AdvancedMarkerElement({
                            map: map,
                            position: homePosition,
                        });

                        this.latlngBounds.extend(homePosition);

                        resolve(this.homeMarker);
                    }
                }
            });
        },

        toggleHighlight(marker, club) {
            document
                .querySelectorAll(".club-popup")
                .forEach((popup) => popup.classList.remove("highlight"));

            if (marker.content.classList.contains("highlight")) {
                marker.content.classList.remove("highlight");
                marker.zIndex = null;
            } else {
                marker.content.classList.add("highlight");
                marker.zIndex = 99;
            }
        },

        getCurrentFilters() {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            let currentFilters = {};

            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }

            return currentFilters;
        },

        toggleFilters(term = "", filterName = "", type = "taxonomy") {
            console.log(term, filterName, type);
            if (!filterName || !type) {
                console.error("Missing filterName or type:", filterName, type);
                return;
            }

            const filter = this.getPrefixedFilter(filterName, type);

            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = term;
                this.fetchContent();
                return;
            }

            if (this.currentFilters[filter].length) {
                if (this.currentFilters[filter].includes(term)) {
                    this.currentFilters[filter] = this.removeFilter(
                        filter,
                        term
                    );
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    this.currentFilters[filter] += "," + term;
                }
            } else {
                this.currentFilters[filter] = term;
            }

            this.fetchContent();
        },

        removeFilter(filter, value) {
            const filterValue = this.currentFilters[filter];
            const filterValueArray = filterValue.split(",");

            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }

            return filterValueArray.toString();
        },

        clearFilters() {
            this.currentFilters = {};
            window.location.href =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname;
        },

        fetchContent(href = null) {
            const clubGrid = this.clubGrid
                ? this.clubGrid.querySelector("[data-pegasus-filterable]")
                : null;
            if (!clubGrid) {
                console.error(
                    "Club grid element not found or missing data-pegasus-filterable."
                );
                return;
            }

            const elements = [
                'data-pegasus-filterable="' +
                clubGrid.dataset.pegasusFilterable +
                '"',
            ];

            if (!Object.keys(this.currentFilters).length) {
                if (href) {
                    this.currentUrl = href;
                } else {
                    window.location.href =
                        window.location.protocol +
                        "//" +
                        window.location.hostname +
                        window.location.pathname;
                    return;
                }
            } else {
                this.currentUrl = this.buildUrl();
            }

            if (href) {
                this.currentUrl = href;
            }

            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.ajaxContent(this.currentUrl, elements, {}, () => {
                    this.isLoading = false;

                    this.fetchClubDataFromDOM();
                    this.refreshMap();

                    if (clubGrid) {
                        pegasus.scroll(clubGrid);
                    } else {
                        console.error(
                            "Club grid element not valid for scrolling."
                        );
                    }

                    history.pushState("", "", this.currentUrl);

                    // Reinitialize modals
                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        filterIsActive(term, filter, type = "taxonomy") {
            const filterName = this.getPrefixedFilter(filter, type);
            if (typeof this.currentFilters[filterName] !== "undefined") {
                return this.currentFilters[filterName].includes(term);
            }
            return false;
        },

        buildUrl() {
            let url =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname +
                "?";
            let i = 1;

            for (const [key, value] of Object.entries(this.currentFilters)) {
                url += `${key}=${value}`;
                if (i < Object.keys(this.currentFilters).length) {
                    url += "&";
                }
                i++;
            }

            return url;
        },

        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        },
    }));
});